import { Typography } from "@mui/material";
import { Grid, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./CreateImageConfigurator.scss";
import Info from "../../../Images/yellow_info_icon.svg";
import ReactTagInput from "@pathofdev/react-tag-input";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import ToolsIcon from "../../../Images/white_info_icon.svg";
import Button from "../../common/Button/index";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, FORM_VALIDATION } from "../../../globals/constants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { S3Client, S3 } from "@aws-sdk/client-s3";
import AWS from "aws-sdk";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API } from "../../../globals/constants";
import MultiLine_Spinner from "../../multiline_spinner/Multiline_spinner";
import { Tooltip } from "@mui/material";
import Upload from "../../../Images/Icon_Upload.svg";
import S3upload from "../../S3 upload";
import { RepeatOneSharp } from "@mui/icons-material";
import {
  imageSelectedData,
  cloudType,
} from "../../../redux/features/ImageConfigReducer";
import { retry } from "@redux-saga/core/effects";
import { imageFormFilled } from "../../../redux/features/ImageConfigReducer";

function ImageConfiguratorForm(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [progress, setProgress] = useState(0);
  const [skills, setSkills] = useState([]);
  const [imageDescription, setImageDescription] = useState("");
  const [boxLink, setBoxLink] = useState("");
  const [isChecked, setIsChecked] = useState("training");
  const [tools, setTools] = useState([]);
  const [toolsSelected, setToolsSelected] = useState([]);
  const [project, setProject] = useState([]);
  const [projectSelected, setProjectSelected] = useState([]);
  const [version, setVersion] = useState("");
  const [projectName, setProjectName] = useState("");
  const [selectedFile, setSelectedFile] = useState(false);
  const [close, setClose] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [nameValidation, setNameValidation] = useState(false);
  const [checkboxSelectedValue, setCheckboxSelectedValue] = useState("private");
  const [chkValue, setChkValue] = useState(false);
  const [flag, setFlag] = useState(true);
  const [error, setError] = useState({
    name: false,
    tools: false,
    skills: false,
    imageDescription: false,
  });
  const onPrivateChange = (e) => {
    setCheckboxSelectedValue(e.target.value);
  };

  const imageData = useSelector((state) => {
    console.log("tstatat00000000", state);
    return state?.ImageDetails?.imageSelectedData;
  });
  const selectedSessionOption = useSelector((state) => {
    return state?.ImageDetails?.cloudType;
  });
  const CreateImageData = useSelector((state) => {
    return state?.ImageDetails?.imageFormFilled;
  });
  const stateAction = useSelector((state) => {
    return state?.ImageDetails?.stateAction;
  });
  const toolData = useSelector((state) => {
    return state?.image_config_list;
  });
  const projectData = useSelector((state) => {
    return state?.image_config_list;
  });
  const imageCreator = useSelector((state) => {
    return state?.image_config;
  });
  const cookies = new Cookies();
  const login = cookies.get("loginData");
  useEffect(() => {
    getImageConfirmation();
  }, [imageCreator?.ImageCreator]);
  const getImageConfirmation = () => {
    if (imageCreator.loading === true) {
    } else {
      if (imageCreator?.ImageCreator?.status === 200) {
        props.handleNext();
      }
    }
  };
  // useEffect(() => {
  //   toolListing();
  // }, [toolData]);
  useEffect(() => {
    projectList();
  }, []);
  // const toolListing = () => {
  //   if (toolData.loading === true) {
  //   } else {
  //     let data = toolData?.ImageListingResponse?.data?.data?.toolList?.rows;
  //     let tool_data = data.map((item) => {
  //       return (item = {
  //         id: +item.id,
  //         label: item.tool_name,
  //         value: item.tool_name,
  //       });
  //     });
  //     setTools(tool_data ? [...tool_data] : []);
  //   }
  // };
  useEffect(() => {
    if (CreateImageData) {
      let tools_value = tools.filter(
        (item) => item.id === CreateImageData?.tool_id
      );
      setToolsSelected(tools_value[0]);
    }
  }, [tools]);
  // const projectListing = () => {
  //   if (toolData.loading === true) {
  //   } else {
  //     let data = toolData?.ImageListingResponse?.data?.data?.projectList?.rows;
  //     let project_data = data.map((item) => {
  //       return (item = {
  //         id: +item.id,
  //         label: item.project_name,
  //         value: item.project_name,
  //       });
  //     });
  //     setProject(project_data);
  //   }
  // };
  useEffect(() => {
    if (CreateImageData) {
      let project_value = project.filter(
        (item) => item.id === CreateImageData?.project_id
      );
      setProjectSelected(project_value[0]);
    }
  }, [project]);
  const handleChange = (selected) => {
    setToolsSelected(selected);
  };
  const handleProject = (selected) => {
    setProjectSelected(selected);
  };
  const isValid = () => {
    let error = true;
    console.log(
      "check the validation data -----",
      FORM_VALIDATION.IMAGE_NAME.test(name.trim())
    );
    if (
      !isEmpty(name.trim()) &&
      skills.length !== 0 &&
      toolsSelected.length !== 0 &&
      !isEmpty(imageDescription) &&
      imageDescription.trim().length !== 0 &&
      FORM_VALIDATION.SCRIPT.test(name.trim()) &&
      FORM_VALIDATION.SCRIPT.test(skills) &&
      FORM_VALIDATION.SCRIPT.test(imageDescription.trim()) &&
      FORM_VALIDATION.IMAGE_NAME.test(name.trim())
    ) {
      return (error = true);
    } else {
      return (error = false);
    }
  };
  const onsubmit = async () => {
    console.log("isvalid ----", isValid());
    setIsloading(true);
    if (isValid()) {
      console.log("isvalid --before--", isValid());

      if (imageDescription.length >= 20) {
        let tools = toolsSelected.map((item) => {
          return parseFloat(item.id);
        });
        // let tools_value = tools.sort();
        let tools_value = tools.sort().toString();
        let tools_array = tools_value.split(",");
        let project =
          projectSelected.length > 0
            ? projectSelected.map((item) => {
                return parseFloat(item.id);
              })
            : null;
        let project_value = project === null ? null : project.sort().toString();
        let project_array =
          project_value === null
            ? null
            : project_value.length > 0
            ? project_value.split(",")
            : project_value;
        const { token, id, role_code, studio_id } = login;
        let bodyParam =
          stateAction?.action === "edit" || stateAction?.action === "retry"
            ? {
                image_name: name.trim(),
                cloud_provider:
                  selectedSessionOption?.sessionType !== "training"
                    ? "GCP"
                    : "AWS",
                skills: skills,
                public: checkboxSelectedValue === "public" ? true : false,
                base_ami:
                  stateAction?.action === "retry"
                    ? imageData?.base_ami
                    : imageData?.ami?.ami_id,
                created_by: id,
                image_description: imageDescription.trim(),
                tool_id: tools_array,
                project_id: project_array,
                edit:
                  stateAction?.action === "edit" ||
                  stateAction?.action === "retry"
                    ? true
                    : false,
                studio_id: studio_id,
                is_edit: CreateImageData?.is_edit + 1,
              }
            : {
                image_name: name.trim(),
                cloud_provider:
                  selectedSessionOption?.sessionType !== "training"
                    ? "GCP"
                    : "AWS",
                skills: skills,
                public: checkboxSelectedValue === "public" ? true : false,
                base_ami:
                  stateAction?.action === "retry"
                    ? imageData?.base_ami
                    : imageData?.ami?.ami_id,
                created_by: id,
                image_description: imageDescription.trim(),
                tool_id: tools_array,
                project_id: project_array,
                edit:
                  stateAction?.action === "edit" ||
                  stateAction?.action === "retry"
                    ? true
                    : false,
                studio_id: studio_id,
              };
        let bodyParamImageCreator = {
          is_accept: false,
          arn: CreateImageData?.image_pipeline_arn,
          ami_name: CreateImageData?.image_name,
          is_edit: CreateImageData?.is_edit,
          created_by: id,
          studio_id: studio_id,
          isFail: false,
          cloud_type:
            selectedSessionOption?.sessionType !== "training" ? "GCP" : "AWS",
        };

        if (stateAction?.action === "edit" || stateAction?.action === "retry") {
          setIsloading(true);
          setError({
            name: false,
            tools: false,
            skills: false,
            imageDescription: false,
          });

          const response = await api_call(
            "POST",
            `${
              CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
              API.END_POINTS.CREATE_IMAGE
            }`,
            {},
            {},
            bodyParam
          );
          setIsloading(true);
          if (response.status === 202) {
            const responseConfirmImage = await api_call(
              "POST",
              `${
                CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
                API.END_POINTS.CONFIRM_IMAGE
              }`,
              {},
              {},
              bodyParamImageCreator
            );
            if (responseConfirmImage.status === 200) {
              setIsloading(false);
            } else {
              setIsloading(false);
            }
            setIsloading(false);
            props.handleNext();
          } else {
            setIsloading(false);
            console.log("bbbbbbbbbb00000000000000", response.err);
            if (response.status === 400) {
              toast.error(`${response.err.data.msg1} `, {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { background: "#000", color: "#ffffff" },
              });
            } else if (response.status === 409) {
              toast.error(`${response.err.data.msg1} `, {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { background: "#000", color: "#ffffff" },
              });
            }
          }
        } else {
          setIsloading(true);
          setError({
            name: false,
            tools: false,
            skills: false,
            imageDescription: false,
          });
          const response = await api_call(
            "POST",
            `${
              CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
              API.END_POINTS.CREATE_IMAGE
            }`,
            {},
            {},
            bodyParam
          );
          if (response.status === 202) {
            setIsloading(false);
            dispatch(cloudType(""));
            props.handleNext();
          } else {
            setIsloading(false);
            console.log("bbbbbbbbbb00000000000000", response.err);
            if (response.status === 400) {
              toast.error(`${response.err.data.msg1} `, {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { background: "#000", color: "#ffffff" },
              });
            } else if (response.status === 409) {
              toast.error(`${response.err.data.msg1} `, {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { background: "#000", color: "#ffffff" },
              });
            }
          }
        }
        // dispatch(ImageCreator({ token, bodyParam }));
        // if (stateAction?.action === "edit" || stateAction?.action === "retry") {
        //   let bodyParam = {
        //     is_accept: false,
        //     arn: CreateImageData?.image_pipeline_arn,
        //     ami_name: CreateImageData?.image_name,
        //     created_by: role_code === "STUDIO_ADMIN" ? studio_id : id,
        //   };
        // dispatch(ConfirmImage({ bodyParam }));
        // }
      } else {
        setIsloading(false);
        if (imageDescription.length < 20) {
          toast.error("Description should be atleast 20 character", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else {
          setIsloading(false);
          toast.error("Please select any one image from the list", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      }
    } else {
      setIsloading(false);
      console.log(
        "isvalid --after--",
        FORM_VALIDATION.IMAGE_NAME.test(name.trim())
      );
      setError(() => {
        return {
          ...error,
          name:
            isEmpty(name) ||
            FORM_VALIDATION.IMAGE_NAME.test(name.trim()) === false
              ? true
              : false,
          skills:
            skills.length === 0 || FORM_VALIDATION.SCRIPT.test(skills) === false
              ? true
              : false,
          tools: toolsSelected.length === 0 ? true : false,
          imageDescription:
            isEmpty(imageDescription) ||
            FORM_VALIDATION.SCRIPT.test(imageDescription.trim()) === false ||
            imageDescription.trim().length === 0
              ? true
              : false,
        };
      });
    }
  };
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };
  let customStyles = {
    option: (styles) => {
      return {
        ...styles,
        backgroundColor: "#141623",
        color: "#fff",
        borderColor: "#4D5369;",
      };
    },
    valueContainer: (styles) => {
      return { ...styles, backgroundColor: "#141623", color: "#fff" };
    },
    control: (styles) => {
      return {
        ...styles,
        backgroundColor: "#141623",
        borderColor: "#4D5369;",
        overflowY: "auto",
        height: "42px",
      };
    },
    singleValue: (styles) => {
      return {
        ...styles,
        color: "#fff",
        fontSize: "12px",
      };
    },
    dropdownIndicator: (styles) => {
      return { ...styles, backgroundColor: "#141623", borderColor: "#313131" };
    },
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "#e6e6e6",
        borderColor: "#313131",
        color: "#fff",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
        fontWeight: "100",
        background: "#313131",
        maxWidth: "200px",
      };
    },
    multiValueRemove: (styles) => {
      return { ...styles, backgroundColor: "#313131", color: "#fff" };
    },
    multiValueLabel: (styles) => {
      return {
        ...styles,
        color: "#fff",
        fontFamily: "Eurostile",
        fontSize: "13",
        height: "25",
      };
    },
    indicatorsContainer: (styles) => {
      return {
        ...styles,
        backgroundColor: "#141623",
        borderColor: "#313131",
        position: " absolute",
        right: "0px",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
      };
    },
    indicatorSeparator: (styles) => {
      return { ...styles, display: "none" };
    },
    clearIndicator: (styles) => {
      return { ...styles, backgroundColor: "#0d0d17", borderColor: "#313131" };
    },
    placeholder: (styles) => {
      return {
        ...styles,
        color: "#636973",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        margin: 0,
        background: "#141623",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
      };
    },
    input: (styles) => {
      return {
        ...styles,
        color: "#ffffff",
        fontFamily: "Eurostile",
        fontSize: "13",
        height: "25",
      };
    },
  };
  const sendEmail = () => {
    let str1 = "Please provide detail information of tools";
    let str2 = "Hello Support team";
    window.open(
      `mailto:monitoring@acc.ltd?Cc=arvind.neelakantan@epicgames.com;rakesh.kumarvali@xa.epicgames.com;&subject=Epic games | Imageconfigurator | New Tool Request&body=Instruction: Please provide detail information of tools`
    );
  };
  const handleTrainings = (event) => {
    onPrivateChange(event.target.value);
  };
  const handleImageName = (e) => {
    setName(e.target.value);

    let check = props?.ImageData.filter(
      (item) => item.ami.name == e.target.value
    );
    console.log("check name validation  before--", check);
    if (check.length > 0) {
      setNameValidation(true);
    } else {
      setNameValidation(false);
    }
  };
  const getListingData = async () => {
    console.log("CreateImage==========", CreateImageData);
    if (CreateImageData !== "") {
      let tools_data = CreateImageData?.tool_id
        ? JSON.parse(CreateImageData?.tool_id)
        : [];
      let tools_value = tools_data.map((value) => {
        let temp = tools.filter((item) => item.id === +value);
        return temp[0];
      });
      let tool_check_value = tools_value.filter((item) => item !== undefined);
      let project_data =
        CreateImageData?.project_id !== null
          ? JSON.parse(CreateImageData?.project_id)
          : null;
      let project_value =
        project_data !== null
          ? project_data.map((value) => {
              let temp = project.filter((item) => item.id === value);
              return temp[0];
            })
          : [];
      let skills = CreateImageData?.skills
        ? JSON.parse([CreateImageData?.skills])
        : [];
      setCheckboxSelectedValue(
        CreateImageData?.is_private === false ? "public" : "private"
      );
      setName(CreateImageData?.image_name);
      setSkills(skills);
      setToolsSelected(tool_check_value);
      setImageDescription(CreateImageData?.image_description);
      setProjectSelected(project_value ? project_value : []);
    }
  };
  const handleClose = async () => {
    setSelectedFile(!selectedFile);
    // dispatch(ImageConfigList({ params }));
    projectList();
    setClose(true);
    // let tools_value = tools.sort();
    if (stateAction?.action === "edit" || stateAction?.action === "retry") {
      let tools = toolsSelected?.map((item) => {
        return parseFloat(item.id);
      });
      let tools_value = tools?.sort().toString();
      let tools_array = tools_value?.split(",");
      let project =
        projectSelected?.length > 0
          ? projectSelected?.map((item) => {
              return parseFloat(item?.id);
            })
          : null;
      let project_value = project === null ? null : project?.sort().toString();
      let project_array =
        project_value === null
          ? null
          : project_value?.length > 0
          ? project_value?.split(",")
          : project_value;
      let data = {
        ami: {
          ami_id: imageData?.ami?.ami_id,
          created_by: imageData?.ami?.created_by,
          discription: imageData?.ami?.discription,
          id: imageData?.ami?.id,
          image_config_ami: imageData?.ami?.image_config_ami,
          is_active: imageData?.ami?.is_active,
          is_private: imageData?.ami?.is_private,
          name: name,
          tool_id: tools_array,
          project_id: project_array,
          region_code: imageData?.ami?.region_code,
          skills: skills,
        },
      };
      console.log("gdsdhhgsdfhgfsdhgs", {
        ami: data.ami,
        project: imageData?.project,
        tools: imageData?.tools,
      });
      if (stateAction?.action === "edit" || stateAction?.action === "retry") {
        dispatch(
          imageFormFilled({
            ami: data.ami,
            project: imageData?.project,
            tools: imageData?.tools,
          })
        );
      }
    } else {
    }
  };
  const projectList = async () => {
    setIsloading(true);
    console.log("check the api flow--");
    const { token, id, role_code, studio_id } = login;
    let params =
      stateAction?.action === "retry"
        ? {
            createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
            cloud_type: CreateImageData?.cloud_provider,
          }
        : {
            createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
            cloud_type:
              selectedSessionOption?.sessionType !== "training" ? "GCP" : "AWS",
          };
    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.IMAGECONFIGURATOR_LIST
      }`,
      params,
      {},
      {}
    );
    if (response.status === 200) {
      setIsloading(false);
      console.log("response---", response?.data?.data?.projectList?.rows);
      let projectName = response?.data?.data?.projectList?.rows;
      let project_data = projectName.map((item) => {
        return (item = {
          id: +item.id,
          label: item.project_name,
          value: item.project_name,
        });
      });
      await setProject(project_data ? [...project_data] : []);
      let data = response?.data?.data?.toolList?.rows;
      let tool_data = data.map((item) => {
        return (item = {
          id: +item.id,
          label: item.tool_name,
          value: item.tool_name,
        });
      });
      await setTools(tool_data ? [...tool_data] : []);
    } else {
      setIsloading(false);
    }
  };
  useEffect(() => {
    getListingData();
  }, [imageData]);
  useEffect(() => {
    // console.log("CreateImageData====", JSON.parse(CreateImageData.project_id));
    getListingData();
  }, [tools]);
  useEffect(() => {}, [project]);
  useEffect(() => {
    if (stateAction?.action === "edit" || stateAction?.action === "retry") {
    } else {
      if (close !== true) {
        console.log("imageData=======", imageData);
        if (imageData) {
          let tools_data = imageData?.tools;
          let tools_value = tools_data?.map((value) => {
            let temp = tools.filter((item) => item.id === +value.id);
            console.log("check tenp----", typeof value.id);
            return temp[0];
          });
          console.log("tools data ----", tools_value, tools_data);
          // setToolsSelected(tools_value);
          let filtered = tools_value
            ? tools_value.filter(function (x) {
                return x !== undefined;
              })
            : [];

          console.log("bnbbnnbbbbbbbbbbbb", filtered);
          let project_data = imageData?.project;
          let project_value =
            project.length > 0
              ? project_data?.map((value) => {
                  let temp = project.filter((item) => item.id === +value.id);
                  return temp[0];
                })
              : [];

          let skills = imageData?.ami?.skills
            ? JSON.parse([imageData?.ami?.skills])
            : [];
          setCheckboxSelectedValue(
            imageData?.ami?.is_private === false ? "public" : "private"
          );
          setName(imageData?.ami?.name);
          setSkills(skills);
          setToolsSelected(filtered);
          setImageDescription(imageData?.ami?.discription);
          setProjectSelected(
            project_value === undefined
              ? []
              : project_value.length > 0
              ? project_value
              : project_value
          );
          // setBoxLink(CreateImageData?.project_link);
        }
      } else {
      }
    }
  }, [tools]);
  useEffect(() => {
    projectList();
  }, [CreateImageData]);
  // useEffect(() => {
  //   console.log("xcxvcbvcxcbxcbxvc", imageData);
  //   if (stateAction?.action === "edit" || stateAction?.action === "retry") {
  //     let tools = toolsSelected?.map((item) => {
  //       return parseFloat(item.id);
  //     });
  //     let tools_value = tools?.sort().toString();
  //     let tools_array = tools_value?.split(",");
  //     let project =
  //       projectSelected?.length > 0
  //         ? projectSelected?.map((item) => {
  //             return parseFloat(item?.id);
  //           })
  //         : null;
  //     let project_value = project === null ? null : project?.sort().toString();
  //     let project_array =
  //       project_value === null
  //         ? null
  //         : project_value?.length > 0
  //         ? project_value?.split(",")
  //         : project_value;
  //     let data = {
  //       ami: {
  //         ami_id: imageData?.ami?.ami_id,
  //         created_by: imageData?.ami?.created_by,
  //         discription: imageData?.ami?.discription,
  //         id: imageData?.ami?.id,
  //         image_config_ami: imageData?.ami?.image_config_ami,
  //         is_active: imageData?.ami?.is_active,
  //         is_private: imageData?.ami?.is_private,
  //         name: name,
  //         tool_id: tools_array,
  //         project_id: project_array,
  //         region_code: imageData?.ami?.region_code,
  //         skills: skills,
  //       },
  //     };
  //     console.log("gdsdhhgsdfhgfsdhgs", {
  //       ami: data.ami,
  //       project: imageData?.project,
  //       tools: imageData?.tools,
  //     });
  //     if (stateAction?.action === "edit" || stateAction?.action === "retry") {
  //       dispatch(
  //         imageFormFilled({
  //           ami: data.ami,
  //           project: imageData?.project,
  //           tools: imageData?.tools,
  //         })
  //       );
  //     }
  //   } else {
  //   }
  // }, [selectedFile]);
  return (
    <>
      <Grid container spacing={2} className="ImageConfiguratorForm">
        {console.log("jjjjprog---", progress)}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Stack direction="row" className="Top_Margin ">
            <Stack direction="row">
              <label className="image_config_btn">
                <input
                  type="radio"
                  value="private"
                  onChange={(e) => onPrivateChange(e)}
                  checked={checkboxSelectedValue === "private" ? true : false}
                />
                <span className="checkmark"></span>
              </label>
              <Tooltip
                title="Account bound images which can be accessed only by you."
                placement="top-start"
                arrow
              >
                <Typography variant="h6" className="FieldHeading">
                  Private
                </Typography>
              </Tooltip>
            </Stack>
            <Stack direction="row">
              <label className="image_config_btn">
                <input
                  type="radio"
                  name="radio"
                  value="public"
                  onChange={(e) => onPrivateChange(e)}
                  checked={checkboxSelectedValue === "public" ? true : false}
                />
              </label>
              <Tooltip
                title="Publicly available images which can be accessed by all Cumulo instructors."
                placement="top-start"
                arrow
              >
                <Typography variant="h6" className="FieldHeading">
                  Public
                </Typography>
              </Tooltip>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Image Name
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
              <input
                className="InputField"
                placeholder="Image Name"
                type="text"
                id="titleNameInput"
                onChange={(e) => handleImageName(e)}
                value={name}
                maxlength={100}
                disabled={stateAction?.action === "edit"}
              />
              {error.name && (
                <small className="error small_f">
                  Enter Valid Image Name *
                </small>
              )}
              {nameValidation && (
                <small className="error small_f">
                  Image Name already exist*
                </small>
              )}
            </Grid>
            {window.innerWidth > 768 ? (
              <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                <div className="">
                  <Tooltip
                    title="Please provide an unique image name. Eg: 'Worldbuilding Fellowship v6 20th July 2023'"
                    placement="top-start"
                    arrow
                  >
                    <img src={Info} className="tooltip-align" />
                  </Tooltip>
                </div>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading AlignCenter">
                Skill Mapping
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
              <div className="TagInputField">
                <ReactTagInput
                  placeholder=" Enter skills"
                  tags={skills}
                  removeOnBackspace={true}
                  onChange={(val) => {
                    setSkills(val);
                  }}
                />
              </div>
              {error.skills && (
                <small className="error small_f">Enter Valid skills *</small>
              )}
            </Grid>
            {window.innerWidth > 768 ? (
              <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                <div className="">
                  <Tooltip
                    title="Provide skills that are associated with the image's usage. You can add multiple skills. Skills are for self-reference only."
                    placement="top-start"
                    arrow
                  >
                    <img src={Info} className="tooltip-align" />
                  </Tooltip>
                </div>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="Top_Margin">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Tools
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
              <div className="TagInputField">
                <ReactSelect
                  placeholder="Select Tools"
                  options={tools}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  styles={customStyles}
                  onChange={handleChange}
                  allowSelectAll={true}
                  value={toolsSelected}
                  isClearable={false}
                />
              </div>
              {error.tools && (
                <small className="error small_f">Please Select Tools *</small>
              )}
            </Grid>
            {window.innerWidth > 768 ? (
              <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                <Tooltip
                  title="Please select all the tools to be installed onto your image. If you don't find the tool you want in this dropdown, please contact support and we can add them (please give 72 hrs to fulfil the request)."
                  placement="top-start"
                  arrow
                >
                  <img src={Info} className="tooltip-align" />
                </Tooltip>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        {selectedSessionOption?.sessionType !== "training" ? (
          ""
        ) : (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className="Top_Margin"
          >
            <Grid container spacing={0}>
              <div className="requestTools">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={0}>
                    <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                      <Typography
                        variant="h6"
                        className="toolText"
                        onClick={sendEmail}
                      >
                        Request for New Tools
                      </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                      <div className="ToolsInfoIcon">
                        <img src={ToolsIcon} />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="Top_Margin"
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <Typography variant="h6" className="FieldHeading">
                Image Description
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <div className="ImageDesc">
                <textarea
                  className="InputField ImageTextDesc"
                  placeholder="Image Description"
                  type="text"
                  id="titleNameInput"
                  onChange={(e) => setImageDescription(e.target.value)}
                  value={imageDescription}
                  minLength={20}
                  maxlength={250}
                />
                {window.innerWidth > 768 ? (
                  <div className="">
                    <Tooltip
                      title="Provide a detailed description of this image. Example 'Image created by John Smith for WorldBuilding Fellowship v6 to start on 20th July 2023. Tools: Unreal Engine 5.1, Blender, Gimp. Projects : Intro_to_UE_v2.zip and WorldBuilding_Fundamentals.zip'"
                      placement="top-start"
                      arrow
                    >
                      <img src={Info} className="tooltip-align" />
                    </Tooltip>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {error.imageDescription && (
                <small className="error small_f">
                  Enter Valid Image Description *
                </small>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Project
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
              <div className="TagInputField">
                <ReactSelect
                  placeholder="Select Project"
                  options={project}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  styles={customStyles}
                  onChange={handleProject}
                  allowSelectAll={true}
                  value={projectSelected}
                  isClearable={false}
                  maxMenuHeight={200}
                />
              </div>
            </Grid>
            {window.innerWidth > 768 ? (
              <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                <div className="">
                  <Tooltip
                    title="Projects are Unreal Engine projects or files that you want your students to have access to during training. The projects will be in the Documents folder. You can select from the existing list of projects or upload a new one."
                    placement="top-start"
                    arrow
                  >
                    <img src={Info} className="tooltip-align" />
                  </Tooltip>
                </div>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="Top_Margin">
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Project
              </Typography>
            </Grid>
            <Grid item xs={8} sm={8} md={7} lg={7} xl={7}>
              <div className="TagInputField">
                <ReactSelect
                  placeholder="Select Project"
                  options={project}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  styles={customStyles}
                  onChange={handleProject}
                  allowSelectAll={true}
                  value={projectSelected}
                  isClearable={false}
                />
              </div>
            </Grid>
            <Grid item xs={2} sm={2} md={1} lg={1} xl={1}></Grid>
          </Grid>
        </Grid> 
        {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="Top_Margin">
          <input
            type="file"
            accept=".zip,.rar,.7zip"
            //  onChange={handleFileInput}
          />
          <button onClick={() => uploadSampleFile(selectedFile)}>
            {" "}
            Upload to S3
          </button>
        </Grid> */}
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="Top_Margin">
          <Grid container spacing={1}>
            <Grid itemxs={1} sm={1} md={1} lg={1} xl={1}>
              <Typography variant="h6" className="Optional">
                {" "}
                Or{" "}
              </Typography>
            </Grid>
            <Grid
              itemxs={10}
              sm={10}
              md={10}
              lg={10}
              xl={10}
              className="Top_Margin"
              onClick={() => setSelectedFile(true)}
            >
              <Grid container spacing={1} className="project-upload">
                <Grid
                  item
                  xs={10}
                  sm={10}
                  md={10}
                  lg={10}
                  xl={10}
                  className="upload_project_heading"
                >
                  Upload Project
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <img src={Upload} className="upload_img"></img>
                </Grid>
              </Grid>
            </Grid>
            <Grid itemxs={1} sm={1} md={1} lg={1} xl={1}></Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container spacing={1}>
            <div className="FlexDisplay btn-align">
              {stateAction?.action === "retry" ? (
                ""
              ) : (
                <Button
                  value="Back"
                  onClick={props.handleBack}
                  role="default"
                  disabled={isLoading}
                />
              )}

              <Button
                value="Create Image"
                onClick={() => onsubmit()}
                role="primary"
                disabled={isLoading}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>
      {selectedFile && (
        <S3upload
          handleClose={handleClose}
          createdBy={
            login?.role_code === "STUDIO_ADMIN" ? login?.studio_id : login?.id
          }
          role={login?.role_code}
        />
      )}
      {isLoading && <MultiLine_Spinner />}
    </>
  );
}

export default ImageConfiguratorForm;
